import { createFeatureSelector, createSelector } from '@ngrx/store';
import { dataExtractionFeatureKey, DataExtractionState } from './extraction-reducer';

export const getDataExtractionState = createFeatureSelector<DataExtractionState>(dataExtractionFeatureKey);

export const getExtractionState = createSelector(getDataExtractionState, (state: DataExtractionState) => state);

export const getSpecifiedExtraction = (extractionId: number) =>
    createSelector(getDataExtractionState, (state: DataExtractionState) =>
        state.extractions.find((extraction) => extraction.id === extractionId)
    );

export const getSelectedConfigureData = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedConfiguration);

export const getSelectedFilters = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedFilters);

export const getIsLoadingSelections = createSelector(getDataExtractionState, (state: DataExtractionState) => state.loading);

export const getExtractionTitle = createSelector(getDataExtractionState, (state: DataExtractionState) => state.title);

export const getExtractionDescription = createSelector(getDataExtractionState, (state: DataExtractionState) => state.description);

export const getSelectedCountries = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedFilters.countries);

export const getSelectedCategories = createSelector(
    getDataExtractionState,
    (state: DataExtractionState) => state.selectedFilters.categories
);

export const getSelectedBrands = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedFilters.brands);

export const getSelectedSuppliers = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedFilters.suppliers);

export const getSelectedAttributes = createSelector(
    getDataExtractionState,
    (state: DataExtractionState) => state.selectedFilters.attributes
);

export const getSelectedAttributeTypes = createSelector(
    getDataExtractionState,
    (state: DataExtractionState) => state.selectedFilters.attributeTypes
);

export const getSelectedRetailerTypes = createSelector(
    getDataExtractionState,
    (state: DataExtractionState) => state.selectedFilters.retailerTypes
);

export const getSelectedRetailers = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedFilters.retailers);

export const getViaExchangeRates = createSelector(
    getDataExtractionState,
    (state: DataExtractionState) => state.selectedConfiguration.exchangeRates
);

export const getReloadedExtraction = createSelector(getDataExtractionState, (state: DataExtractionState) => state.reloadedExtraction);
